/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateOrganizationIPWhitelistResponseData } from './CreateOrganizationIPWhitelistResponseData';
import {
    CreateOrganizationIPWhitelistResponseDataFromJSON,
    CreateOrganizationIPWhitelistResponseDataFromJSONTyped,
    CreateOrganizationIPWhitelistResponseDataToJSON,
} from './CreateOrganizationIPWhitelistResponseData';

/**
 * 
 * @export
 * @interface CreateOrganizationIPWhitelistResponse
 */
export interface CreateOrganizationIPWhitelistResponse {
    /**
     * 
     * @type {CreateOrganizationIPWhitelistResponseData}
     * @memberof CreateOrganizationIPWhitelistResponse
     */
    data?: CreateOrganizationIPWhitelistResponseData;
}

/**
 * Check if a given object implements the CreateOrganizationIPWhitelistResponse interface.
 */
export function instanceOfCreateOrganizationIPWhitelistResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateOrganizationIPWhitelistResponseFromJSON(json: any): CreateOrganizationIPWhitelistResponse {
    return CreateOrganizationIPWhitelistResponseFromJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationIPWhitelistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreateOrganizationIPWhitelistResponseDataFromJSON(json['data']),
    };
}

export function CreateOrganizationIPWhitelistResponseToJSON(value?: CreateOrganizationIPWhitelistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateOrganizationIPWhitelistResponseDataToJSON(value.data),
    };
}

